<template>
    <div class="addMater">
      <div class="header">
        <h3><i></i>添加素材</h3>
        <div class="header-btn">
          <el-button type="primary" size="mini" @click="materialCancel">取消</el-button>
          <el-button type="primary" size="mini" @click="submitMaterialBtn">保存</el-button>
        </div>
      </div>
      <div class="material_main">
        <div class="material-item">
          <h3>科目：{{subjectName}}</h3>
          <div class="item-header" style="position: relative;">
            <el-form :inline="true" :model="conditionList" class="demo-form-inline">
            <!-- <el-select
              v-model="conditionList.materialSubjectName"
              @change="materialSubjectNameChange"
              placeholder="请选择科目"
              size="mini"
              class="material_state"
            >
              <el-option
                v-for="(item, i) in conditionList.materialSubjectNames"
                :key="i"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
              <el-select
                v-model="conditionList.materialType"
                @change="queryPostCollegeLists"
                placeholder="请选择类型"
                size="mini"
                clearable
                class="material_type"
              >
                <el-option
                  v-for="(item, i) in conditionList.materialTypes"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input
                v-model="conditionList.phoneOrName"
                @keyup.enter.native="queryPostCollegeLists"
                placeholder="请输入上传人"
                clearable
                class="material_tel"
              ></el-input>
              <el-input
                v-model="conditionList.materialName"
                @keyup.enter.native="queryPostCollegeLists"
                placeholder="请输入素材名称"
                clearable
                class="material_name"
              ></el-input>
              <template>
                <el-button type="query" class="material-query" @click="queryPostCollegeLists()" >查询</el-button>
              </template>
            </el-form>
            <div style="position: absolute; right: 0; background: white;">
              <!--<el-button type="examine" class="material-examine" @click="showexamine()" >审核</el-button>-->
              <!--                            <el-button type="examine" class="add-material" @click="openSource">开放</el-button>-->
            </div>
          </div>
        </div>
      </div>
      <div class="main-box">
        <span class="trainClose" :class="isShow ? 'train-open' : ''" @click="isShow = !isShow"></span>
        <div :class="isShow ? 'isShow' : ''">
          <LeftTree @showList="showList" ref="leftTree"></LeftTree>
        </div>
        <div class="material-item-right" v-loading="loading">
          <span>已选 {{this.tableIds.length}} 个</span>
          <div class="material-content-table">
            <el-table
              ref="multipleTable5"
              :data="tableData3"
              tooltip-effect="dark"
              style="width: 100%;"
              @selection-change="tableSelect"
              :header-cell-style="{ background: '#edf4ff', color: '#999999' }"
              :style="'height:' + contentHeight"
            >
              <el-table-column
                type="selection"
                :selectable="selectable"
                width="55">
              </el-table-column>
              <el-table-column
                prop="name"
                label="素材名称"
                show-overflow-tooltip
                popper-class="bgtext">
                <template slot-scope="scope">
                  <span v-if="scope.row.transcodeStatus == 2" style="color: red; padding-right: 5px;">[转码中]</span>
                  <span v-else-if="scope.row.transcodeStatus == 3" style="color: red; padding-right: 5px;">[转码失败]</span>
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column prop="type" label="类型" width="100">
                <!--插入图片-->
                <template slot-scope="scope">
                  <!--  <img :src="typeimg(scope.row.type)" alt="" class="type_pic" style="width: 24px;height: 24px;border-radius:50%;vertical-align: middle">-->
                  {{ scope.row.type | typeStr }}
                </template>
              </el-table-column>
              <el-table-column prop="createUseStr" label="上传人" width="130" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap">
                    {{ scope.row.createUseStr}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                :formatter="formatCreateTime"
                label="上传时间"
                width="120">
              </el-table-column>
              <el-table-column
                prop="operation"
                label="操作"
                align="center"
                width="200">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    plain
                    @click="viewDetaial(scope.row)"
                    :disabled="scope.row.transcodeStatus != 1"
                  >查看</el-button>
                </template>
                <el-drawer
                  :append-to-body="true"
                  :visible.sync="isMaterialDetails"
                  size="80%"
                  :direction="direction"
                  :with-header="false">
                  <materialDetails :detailData="detailData" @closeDrawe="closeDrawe" ref="materialDetail"></materialDetails>
                </el-drawer>
              </el-table-column>
              <div slot="empty" class="empty_material">
                <img src="../../../assets/image/sources/wujieguo.png" alt="加载失败"/>
                <p>该目录暂无素材</p>
              </div>
            </el-table>
            <Pagination
              :currentpage="pageTotal.currentPage"
              :limit="pageTotal.pageSize"
              :total="pageTotal.total"
              layout="sizes, prev, pager, next, jumper"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
              :small="true"
            ></Pagination>
          </div>
        </div>
        <el-table
          ref="multipleTable4"
          :data="gridData.list"
          tooltip-effect="dark"
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
          @selection-change="handleSelectionChange">
          <template slot="empty" v-if="gridData.list&&gridData.list.length==0">
            <div class="empty_data">
              <img src="../../../assets/image/sources/wujieguo.png"/>
              <p>暂无数据</p>
            </div>
          </template>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column property="name" label="素材名称" show-overflow-tooltip></el-table-column>
          <el-table-column property="type" label="类型" width="90">
            <template slot-scope="scope">
              <img :src="srcValue(scope.row.type,1)" alt="加载失败" style="width:24px;height:24px;"/>
            </template>
          </el-table-column>
          <el-table-column property="createUseStr" label="上传人" width="90" show-overflow-tooltip></el-table-column>
          <el-table-column property="createUseStr" label="上传时间" width="90" show-overflow-tooltip></el-table-column>
          <el-table-column fixed="right" label="操作" width="105">
            <template slot-scope="scope">
              <el-button @click="handleClickSee(scope.row)" round>查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="empty" class="empty_material" v-show="(!materialId || materialId == '') && !isTreeShow">
        <img src="../../../assets/image/sources/wujieguo.png" alt="加载失败"/>
        <p>没有可用科目</p>
      </div>
    </div>
</template>

<script>
    import * as courseAPI from '../../../api/courseApi'
    import LeftTree from "../../leftTree";
    // import * as api from '../../../../api/apiList/sourceApi'
    import * as api from '../../../api/sourceApi'
    import Pagination from "../../paginator/paginator";
    import materialDetails from "./materialDetails";
    import Axios  from 'axios'
    import qs from "qs"
    export default {
        name: "addMaterial.vue",
        components:{
            materialDetails,
            LeftTree,
            Pagination
        },
        data(){
            return {
                isMaterialDetails:false,
                permissions:window.localStorage.getItem('permissions'),
                isShow: false,
                msg: "资源库",
                input: "",
                value: "",
                loading: false,
                previewUrl: null,
                tableData3: [],
                direction:"rtl",
                detailData:{},
                //条件查询
                conditionList: {
                    //素材名称
                    materialName: "",
                    materialType: "",
                    materialstate: "",
                    userPhoneOrName: "",
                    materialTypes: [
                        {value: "1", label: "图片"},
                        {value: "2", label: "文档"},
                        {value: "3", label: "音频"},
                        {value: "4", label: "视频"},
                        {value: "5", label: "zip"},
                    ],
                    materialstates: [
                        {value: "1", label: "通过"},
                        {value: "2", label: "已驳回"},
                        {value: "3", label: "待审核"},
                    ],
                    materialSubjectNames: [],
                    materialSubjectName: "",
                },
                materialId: null,
                multipleSelection: [],
                tableIds: [],
                dialogTableVisible: false,
                dialogFormVisible: false,
                formLabelWidth: "120px",
                //分页数据
                pageTotal: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                },
                // 添加素材
                headleresetForm: false,
                centerDialogVisible: false,
                materialDialogVisible: {
                    add: false,
                    view: false,
                    edit: false,
                },
                gridData: [
                    { list:''}
                ],
                auth: {
                    save: false,
                    detail: false,
                    update: false,
                    delete: false,
                    review: false,
                },
                isTreeShow: false,
                materialObjData: {},
                subjectName:"",
            };
        },
        watch: {},

        beforeDestroy() {
            // bus.$off("materialObj");
            // bus.$off("showLists");
        },
        created() {
            this.postCollegeLists();
            // bus.$on("materialObj", (params) => {
            //     this.materialObjData = params;
            // });
        },

        computed: {
            contentHeight() {
                if (this.tableData3.length && this.pageTotal.total > this.pageTotal.pageSize) {
                    return window.innerHeight - 190 + "px";
                } else {
                    return window.innerHeight - 180 + "px";
                }
            },
        },
        mounted() {
            // console.log(this.subjectId,"saew")
            this.getMaterialSubjectName();
            // bus.$on("showLists", this.showLists);
        },
        props: ['subjectId'],
        //类型  1图片，2文档, 3音频，4视频,5zip
        filters: {
            typeStr(type) {
                switch (type) {
                    case 1:
                        return "图片";
                    case 2:
                        return "文档";
                    case 3:
                        return "音频";
                    case 4:
                        return "视频";
                    case 5:
                        return "zip";
                    default:
                        break;
                }
            },
            msg(type) {
                switch (type) {
                    case 1:
                        return "通过";
                    case 2:
                        return "已驳回";
                    case 3:
                        return "待审核";
                    default:
                        break;
                }
            },
        },
        methods: {
            viewDetaial(row){
                if(row.type==5){
                    this.handlegetZip(row.newAttaUrl);
                }else{
                    this.isMaterialDetails=true;
                    this.detailData = row;
                    if(this.$refs.materialDetail){
                        this.$refs.materialDetail.clearField();
                        this.$refs.materialDetail.init(row)
                    }
                }

            },
            closeDrawe(){
              this.isMaterialDetails=false;
            },
            // eslint-disable-next-line no-irregular-whitespace
            // transcodeStatus  转码状态 1不需要转码 2转码中 3转码失败
            selectable(row) {
                if (row.transcodeStatus == 2 || row.transcodeStatus == 3) {
                    return false;
                }
                return true;
            },
            formatCreateTime(item) {
                if (!item || !item.createTime) return "";
                var date = new Date(item.createTime);
                var fmt = "yyyy-MM-dd";
                var o = {
                    "M+": date.getMonth() + 1, //月份
                    "d+": date.getDate(), //日
                    "h+": date.getHours(), //小时
                    "m+": date.getMinutes(), //分
                    "s+": date.getSeconds(), //秒
                    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                    S: date.getMilliseconds(), //毫秒
                };
                if (/(y+)/.test(fmt))
                    fmt = fmt.replace(
                        RegExp.$1,
                        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
                    );
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt))
                        fmt = fmt.replace(
                            RegExp.$1,
                            RegExp.$1.length == 1
                                ? o[k]
                                : ("00" + o[k]).substr(("" + o[k]).length)
                        );
                return fmt;
            },
            typeimg(type) {
                switch (type) {
                    case 1:
                        return "../../../static/img/picture.png";
                    case 2:
                        return "../../../static/img/wenjian.png";
                    case 3:
                        return "../../../static/img/yinpin.png";
                    case 4:
                        return "../../../static/img/video.png";
                    case 5:
                        return "../../../static/img/zip.png";
                    default:
                        break;
                }
            },
            handleClickSee(){
              console.log("xxxxxxxxxxxxxx")
            },
            //树科目管理

            getMaterialSubjectName() {
                api.getMaterialTreeListById(this.subjectId, {}).then((res) => {
                    if (res.code == "0") {
                        console.log(res.data,"oqepwie")
                        this.subjectName=res.data.name;
                        // this.conditionList.materialSubjectNames = res.data
                        // this.conditionList.materialSubjectNames = res.data.map((item) => {
                        //     let {id, name} = item;
                        //     let obj = {id, name};
                        //     return obj;
                        // });
                        this.$refs.leftTree.treeList(this.subjectId);
                    }
                    // if (this.conditionList.materialSubjectNames && this.conditionList.materialSubjectNames.length > 0) {
                    //     let subjectId = sessionStorage.getItem("sckSubjectId");
                    //     if(subjectId){
                    //         console.log(subjectId,"xxxxxxxxxxxxxxxxxxxxxx")
                    //         console.log(this.conditionList.materialSubjectNames,"0000000000000000000")
                    //         let idx = this.conditionList.materialSubjectNames.findIndex((item,index) =>{if(item.id==subjectId){return true;}});
                    //         console.log(idx,"22222222222222222222");
                    //         this.conditionList.materialSubjectName = this.conditionList.materialSubjectNames[idx].id;
                    //     }else{
                    //         //默认选中第一个
                    //         this.conditionList.materialSubjectName = this.conditionList.materialSubjectNames[0].id;
                    //     }
                    //     if (this.$refs.leftTree) {
                    //         this.$refs.leftTree.treeList(this.conditionList.materialSubjectName);
                    //     }
                    // }
                });
            },

            showList(id,subjectId, isTreeShow) {
                if (isTreeShow) {
                    this.loading = true;
                    this.materialId = id;
                    this.isTreeShow = isTreeShow;
                    this.subjectId=subjectId;
                    this.pageTotal.pageSize=10;
                    this.pageTotal.pageNum=1;
                    this.postCollegeLists();
                } else {
                    this.pageTotal.pageSize=10;
                    this.pageTotal.pageNum=1;
                    this.loading = true;
                    this.materialId = "";
                    this.isTreeShow = isTreeShow;
                    this.subjectId=subjectId;
                    this.postCollegeLists();
                }
            },
            showLists(id,subjectId) {
                this.materialId = id;
                this.subjectId=subjectId;
                this.pageTotal.pageSize=10;
                this.pageTotal.pageNum=1;
                this.postCollegeLists();
            },

            tableSelect(data) {
                this.multipleSelection = data;
                console.log(this.multipleSelection);
                this.tableIds = data.map((x) => x.id);
                console.log(this.tableIds.length);
            },
            // 添加素材
            showAddmaterial() {
                this.$router.push({
                    name: "add-material-detailSecond",
                    params: {materialObjData:this.materialObjData},
                });

                // if (this.materialId) {
                //   this.materialDialogVisible.add = true;
                //   this.materialDialogVisible.edit = false;
                //   this.materialDialogVisible.view = false;
                //   this.materialDialogVisible.delete = false;
                //   this.$refs.materialDetail.emptyParam();
                // } else {
                //   this.$message.warning("请选择素材节点");
                // }
            },
            // 修改素材
            handleEdit(index, row) {
                // this.materialDialogVisible.add = false;
                // this.materialDialogVisible.edit = true;
                // this.materialDialogVisible.view = false;
                // this.materialDialogVisible.delete = false;
                // console.log(row,"llllllllllllll");
                // this.$refs.materialDetail.editMaterial(row);
            },

            // 审核
            // showexamine() {
            //     if (this.tableIds && this.tableIds.length !== 0) {
            //         this.$refs.examineMaterial.examineDialogVisible = true;
            //         let obj = {attaIds: this.tableIds, materialId: this.materialId};
            //         this.$refs.examineMaterial.showList(obj);
            //     } else {
            //         this.$message({
            //             showClose: true,
            //             message: "请勾选需审核的素材",
            //             type: "warning",
            //         });
            //     }
            // },
            // 删除素材列表
            handleDelete(index, value) {
                // this.materialDialogVisible.add = false;
                // this.materialDialogVisible.edit = false;
                // this.materialDialogVisible.view = false;
                // this.materialDialogVisible.delete = true;
                // this.$refs.materialDetail.deleteMaterial(value);
            },
            // 查看
            handlesee(row) {
                // this.$router.push({
                //   name: "material-details",
                //   params: {id: row.id, type: row.type, filePath: row.newAttaUrl},
                // });
                console.log("999999999999jjjjjjjj")

                if (row.type == 5){
                    this.handlegetZip(row.newAttaUrl)
                }else {
                    this.$router.push({
                        name: "material-details",
                        params: {id: row.id, type: row.type, filePath: row.newAttaUrl},
                    });
                }
                // if(value.type==5){
                //     this.$refs.materialDetail.viewMaterial(value,'view');
                // }else{
                //     this.materialDialogVisible.add = false;
                //     this.materialDialogVisible.edit = false;
                //     this.materialDialogVisible.view = true;
                //     this.$refs.materialDetail.viewMaterial(value,'view');
                // }
            },
            handlegetZip(filePath) {
                let obj = {filePath:filePath};
                Axios.post(`${process.env.UPLOAD_NAME}`+'/file/doesObjectExistZip',qs.stringify(obj),{
                    headers: {
                        // 用户认证token
                        'Content-Type': 'application/x-www-form-urlencoded',
                        // 'Content-Type': 'application/json',
                        Authorization: 'bearer '+localStorage.getItem('Authorization')
                    },
                }).then((res) =>{
                    if (res.data.code == 0) {
                        window.open(filePath, "_blank");
                    } else {
                        this.$message.warning("无法预览");
                    }
                })
            },
            // 页码切换
            // pageChange(item) {
            //     this.pageTotal.pageNum = item;
            //     this.postCollegeLists();
            // },
            handlePreview(url, type) {
                this.previewUrl = url;
                this.previewType = type;
            },
            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                this.imageUrl = "../../../static/img/course_kong.png";
                const isJPG = file.type === "image/jpeg";
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error("上传头像图片只能是 JPG 格式!");
                }
                if (!isLt2M) {
                    this.$message.error("上传头像图片大小不能超过 2MB!");
                }
                return isJPG && isLt2M;
            },
            // 素材列表数据
            postCollegeLists() {
                this.tableData3 = [];
                let obj = {
                    materialId: this.materialId,
                    pageNum: this.pageTotal.currentPage,
                    pageSize: this.pageTotal.pageSize,
                    name: this.conditionList.materialName,
                    type: this.conditionList.materialType,
                    status: this.conditionList.materialstate,
                    phoneOrName: this.conditionList.phoneOrName,
                    subjectId:this.subjectId
                };
                api
                    .getMaterialList(obj, {
                        method: "post",
                        // contentType: "application/json",
                    })
                    .then((res) => {
                        if(res.code=="0"){
                            this.tableData3 = res.data.list;
                            if(this.tableData3.length>0){
                                let {total,pageNum:currentPage, pageSize} = res.data;
                                this.pageTotal = {total, currentPage,pageSize};
                            }else{
                                this.pageTotal = {currentPage:1,pageSize:10};
                            }
                        }
                        this.loading = false;
                    }).catch((error) => {
                    console.log(error);
                });
            },
            queryPostCollegeLists() {
                this.postCollegeLists();
            },
            // 树选择
            materialSubjectNameChange() {
                sessionStorage.setItem("sckSubjectId",this.conditionList.materialSubjectName);
                this.$refs.leftTree.treeList(this.conditionList.materialSubjectName)
            },
            handleCurrentChange(val) {
                this.pageTotal.currentPage = val;
                this.postCollegeLists()
            },
            handleSizeChange(val){
                this.pageTotal.pageSize = val;
                this.pageTotal.currentPage = 1;
                this.postCollegeLists()
            },
            sizeChangeFn(val) {
                this.pageTotal.pageSize = val;
                this.postCollegeLists();
            },

            openSource() {
                if (this.tableIds && this.tableIds.length !== 0) {
                    let isEmpty = false;
                    this.multipleSelection.forEach((val) => {
                        if (val.status != 1) {
                            isEmpty = true;
                            return;
                        }
                    });
                    if (isEmpty) {
                        this.$message.warning("审核通过的素材才能开放");
                        return;
                    }
                    this.$refs.openMaterial.dialogVisible = true;
                    let obj = {attaIds: this.tableIds, materialId: this.materialId};
                    this.$refs.openMaterial.showList(obj);
                } else {
                    this.$message({
                        showClose: true,
                        message: "请勾选需开放的素材",
                        type: "warning",
                    });
                }
            },
            //table样式
            cellStyle(data) {
                if(data.columnIndex == 1 || data.columnIndex == 3){
                    return "text-align:left !important"
                }
            },
            headerCellStyle({ row, column, rowIndex, columnIndex }) {
                if (rowIndex === 0 && (columnIndex == 1 || columnIndex == 3)) {
                    return "background:rgba(83,151,247,0.1);color:#999999;text-align:left !important;"
                }else{
                    return "background:rgba(83,151,247,0.1);color:#999999;"
                }
            },
            //选择素材
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 取消
            materialCancel(){
                // this.closeAddMaterial=false;
                this.$emit("closeAddMaterial");
              this.$refs.multipleTable5.clearSelection()
            },
            // 保存
            submitMaterialBtn(){
                let newArr = [];
                this.tableIds.forEach(item=>{
                    let obj = {};
                    obj.catalogId = this.$store.state.catalogId;
                    obj.courseId = this.$route.query.id;
                    obj.resourceId = item;
                    obj.type = 1;
                    newArr.push(obj);
                })
                let param = {
                    catalogId:this.$store.state.catalogId,
                    courseId:this.$route.query.id,
                    list:newArr
                }
                api.submitMaterialBtn(param).then(res=>{
                    if(res.code == '0'){
                        this.$message.success("保存成功");
                      this.$refs.multipleTable5.clearSelection()
                        this.$emit("closeAddMaterial")
                    }else{
                        this.$message.warning(res.msg);
                    }
                }).catch(error=>{
                    console.log(error);
                })

            }
        }
    }
</script>

<style scoped  lang="scss">
  .addMater{
    .header{
      height: 50px;
      line-height: 50px;
      padding: 0px 10px;
      border-bottom:1px solid rgba(221,224,226,1);
      h3{
        font-size: 16px;
        color: #0D0D0D;
        font-weight: bold;
        float: left;
        i{
          display: inline-block;
          width:4px;
          height: 17px;
          background: #5397f7;
          vertical-align: middle;
          margin-right: 6px;
        }
      }
      .header-btn{
        float: right;
      }
    }
    .main-item{
      padding: 16px 16px 0;
      display: -webkit-box;
      display: -ms-flexbox;
      /* display: flex; */
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      .material_dialog_left{
        width: 200px;
        height:358px;
        border:1px solid rgba(235,235,235,1);
        opacity:1;
        border-radius:4px;
        overflow: auto;
        h2{
          color: #0D141E;
          font-size: 12px;
          line-height: 30px;
          padding-left: 20px;
        }
        .tree_wrap{
          .tree_title{
            width: 100%;
            height: 32px;
            background: #5397f7;
            border-radius: 4px 4px 0px 0px;
            position: relative;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            font-weight: 400;
            line-height: 32px;
            color: white;
            padding: 0 12px;
            box-sizing: border-box;
          }
        }
        .el-tree-node__content{
          height: 32px;
          position: relative;
          .el-tree-node__expand-icon{
            color: #5397F7;
          }
          .el-tree-node__expand-icon.is-leaf{
            color: transparent !important;
            cursor: default;
          }
          .custom-tree-node{
            font-size:12px;
            font-weight:400;
            color: #333333;
            width: 80%;
            span:first-child{
              display:inline-block;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .course_catalog_operation{
            // position: absolute;
            // top: 2px;
            // right: 10px;
            i{
              margin-left: 3px;
            }
          }
        }
        .el-tree-node.is-current > .el-tree-node__content {
          background-color: #EDF4FF;
          border-left: 2px solid #5397F7;
        }
        .el-tree-node__content:hover{
          background: #EDF4FF;
        }
      }
      .material_dialog_right{
        width: 80%;
        .material_search{
          display: flex;
          .material_name input,.material_type input,.material_tel input{
            height:30px;
            border:1px solid rgba(226,226,226,1);
            border-radius:4px;
          }
          .material_name{
            width: 160px;
            margin-right:16px;
          }
          .material_type{
            width:150px;
            margin-right:16px;
          }
          .material_tel{
            width:200px;
            margin-right:24px;
          }
          .el-input .el-input__inner{
            font-size: 12px;
            padding: 0 10px 0 25px;
          }
          .el-select .el-input__inner{
            font-size: 12px;
            padding: 0 20px 0 10px;
          }
          .el-input__icon{
            width: 15px;
            line-height: 30px;
          }
        }
        .el-table{
          width:100%;
          height:280px;
          border:1px solid rgba(235,235,235,1);
          border-radius:4px;
          margin-top: 8px;
          .el-table__body-wrapper{
            .el-table__body{
              .el-table__row{
                line-height: 40px;
                td{
                  img{
                    margin-top:6px;
                  }
                }
              }
            }
            .empty_data{
              img{
                width: 100px;
              }
              p{
                color:#909399;
              }
            }
          }
        }
      }
    }
  }
  .trainClose {
    z-index: 35;
    position: absolute;
    left: 18%;
    top: 50%;
    width: 16px;
    height: 50px;
    margin-top: -25px;
    cursor: pointer;
    background: url("../../../assets/image/sources/close.png") no-repeat;
    background-size: 16px 50px;
    transition: all 0.3s ease-in-out;
  }
  .train-open {
    left: 0;
    background: url("../../../assets/image/sources/open.png") no-repeat;
    background-size: 16px 50px;
    transition: all 0.3s ease-in-out;
  }
  .isShow {
    width: 0;
    opacity: 0;
    transition: all 0.3s ease-in-out;
  }
  /deep/ .el-dialog__header {
    background: #edf4ff;
    border-radius: 8px 8px 0 0;
    height: 18px;
    &:before {
      width: 2px;
      height: 10px;
      background: rgba(83, 151, 247, 1);
      opacity: 1;
      border-radius: 4px;
    }
  }
  /deep/ .el-dialog__title {
    display: block;
    font-size: 14px;
    color: #5397f7;
    border-left: 2px solid #5397f7;
    padding-left: 5px;
    line-height: 10px;
  }
  /*/deep/ .el-input,*/
  /*.el-textarea {*/
  /*  width: 260px;*/
  /*}*/
  /deep/ .el-textarea__inner {
    resize: none;
  }
  //树的input框
  /deep/ .el-tree-node__content {
    height: 34px;
    line-height: 34px;
  }

  /deep/ .el-dialog__body {
    padding-top: 24px;
    padding-bottom: 0px;
    margin: 16px;
  }
  /deep/ .el-dialog__footer {
    .el-button {
      width: 79px;
      height: 32px;
      line-height: 32px;
      padding: 0;
    }
  }
  /deep/ .bgtext {
    background-color: #ccc;
  }
  /deep/ .el-table th {
    padding: 9px 0;
  }
  /deep/ .el-table td {
    padding: 6px 0;
  }
  /deep/ .el-table::before {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
  }
  // 审核素材
  /deep/ .el-table {
    border: 1px solid rgba(235, 235, 235, 1);
    border-radius: 4px;
    width: 656px;
    margin: 0 auto;
    overflow: auto;
    /*height: calc(100vh - 100px);*/
  }
  /deep/ .el-table .cell.el-tooltip {
    text-align: left;
  }
  .viewimg {
    width: 560px;
    height: 462px;
    background: rgba(238, 238, 238, 1);
    opacity: 1;
    border-radius: 0px 0px 0px 8px;
  }

  .main-box{
    width: 100%;
    .material-aside{
      width:18%;
      height:518px;
      border:1px solid rgba(235,235,235,1);
      border-radius:4px;
      float: left;
      overflow: auto;
      background: white;
    }
    .material-item-right{
      //width: 81%;
      //float: right;
      height: calc(100vh - 100px);
      margin-top: 10px;
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      overflow-y: auto;
      border-radius: 4px;
      padding: 0px 5px;
      span{
        display: inline-block;
        font-size: 12px;
        color: #5D646E;
        padding-bottom: 8px;

      }
    }
  }
  .material-content-table{
    // border:1px solid rgba(235,235,235,1);
    border-radius:4px;
    cell> span{
      color: pink;
    }
    //button> span{
    //    color:rgba(83,151,247,1);
    //}
  }
  .el-message-box{
    width:420px!important;
    height:240px!important;
    background:rgba(255,255,255,1)!important;
    border-radius:8px;
  }
  .t-user-modify-tree{
    &.t-tree{
      .el-tree-node{
        .is-leaf + .el-checkbox .el-checkbox__inner{
          display: inline-block
        }
        .el-checkbox__input>.el-checkbox__inner{
          display: none
        }
      }
    }
  }
  .empty_material{
    text-align: center;
    img{
      width: 140px;
      height: 140px;
      margin-top: 100px;
    }
    p{
      font-size:14px;
      font-weight:400;
      line-height:16px;
      color:#999999;
    }
  }
  .material_main{
    width: 100%;
    /*    margin: 8px 0px;*/
    background: #f0f3fa ;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 45px;
    line-height: 45px;
    border-radius: 4px;
    .material-item{
      height: 40px;
      border-radius: 4px 4px 0px 0px;
      display: flex;
      h3{
        font-size: 12px;
        color: #0D141E;
        padding-left: 16px;
        font-weight: bold;
      }
      .item-header{
        width: auto;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: -webkit-box;
        display: inline-block;
        padding-left: 10px;
        .el-input{
          width: auto;
          margin-right: 10px;
        }
        .material_name{
          .el-input__icon{
            height:30px;
          }
        }
        .el-select{
          width: auto;
        }

        /deep/ .el-input--suffix .el-input__inner{
          /*width:160px;*/
          height:30px;
          line-height: 30px;
          border-radius:4px;
          .el-input__icon{
            line-height: 30px!important;
          }
        }
        .el-input__icon{
          line-height: 30px!important;
        }
        .material_tel input{
          width:200px;
          height:30px;
          border-radius:4px;
        }
        .material-query{
          width: 72px;
          height: 30px;
          line-height: 30px;
          padding: 0;
          color: #5397F7;
          border: 1px solid #5397f7;
          font-size: 12px;
          margin-top: 8px;
          &:hover{
            width: 72px;
            height: 30px;
            line-height: 30px;
            padding: 0;
            background:rgba(83,151,247,.8);
            border:1px solid rgba(83,151,247,.8);
            color:rgba(255,255,255,1);
            font-size: 12px;
            margin-right: 9px;
          }
        }
        .material-examine{
          width: 80px;
          height: 30px;
          line-height: 30px;
          padding: 0;
          color: #5397F7;
          border: 1px solid #5397f7;
          font-size: 12px;
          &:hover{
            width: 80px;
            height: 30px;
            line-height: 30px;
            padding: 0;
            background:rgba(83,151,247,.8);
            border:1px solid rgba(83,151,247,.8);
            color:rgba(255,255,255,1);
            font-size: 12px;
          }
        }
        .add-material{
          width: 80px;
          height: 30px;
          line-height: 30px;
          padding: 0;
          color: #5397F7;
          border: 1px solid #5397f7;
          font-size: 12px;
          margin: 0;
          &:hover{
            width: 80px;
            height: 30px;
            line-height: 30px;
            padding: 0;
            background:rgba(83,151,247,.8);
            border:1px solid rgba(83,151,247,.8);
            color:rgba(255,255,255,1);
            font-size: 12px;
          }
        }

      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/course/addMaterial.vue